import apiClient from './api';
import { AxiosRequestConfig } from 'axios';

export class DischargedService {
  async get(params: AxiosRequestConfig = {}): Promise<number> {
    return await apiClient.get('/copd/patient-app/discharged', params);
  }
}
